module.exports = __webpack_public_path__ + "img/user.d02a6267.svg";